module.exports = __webpack_public_path__ + "747c6b6a.svg";